import styled from 'styled-components'
import {
  boxShadow,
  primary,
  navy,
  bgPrimaryLight,
  widthFull,
  widthResize,
  heightHeader,
  widthWithPadding,
  widthResizeWithPadding,
  radiusMd,
  radiusPill
} from '../Resources/Theme'

const Nav = styled.div`
  position: fixed;
  width: ${props => props.resize && !props.resizeOpen ? widthResize : widthFull};
  height: 100%;
  background: ${navy};
  overflow: hidden;
  transition: width 0.28s ease, margin 0.28s ease;
  z-index: 0;

  &:hover {
    overflow: auto;
    overflow-x: hidden;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    position: fixed;
    margin-top: ${heightHeader};
  }

  &::-webkit-scrollbar {
    width: 0.3rem;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.25);
    border-radius: 6px;
  }

  @media (max-width: 992px) {
    width: ${widthFull};
    margin-left: -${props => props.mobile ? '0' : '280'}px;
    overflow: auto;
    overflow-x: hidden;
    z-index: 99;
    transition: margin 0.28s ease;
  }
`

Nav.Bg = styled.div`
  display: none;

  @media (max-width: 992px) {
    display: ${props => props.mobile ? 'block' : 'none'};
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: ${bgPrimaryLight};
    backdrop-filter: blur(2px);
    z-index: 99;
  }
`

Nav.Title = styled.div`
  height: auto;
  width: ${props => props.resize && !props.resizeOpen ? widthResizeWithPadding : 'auto'};
  font-weight: 600;
  padding: 12px 20px 8px;
  display: flex;
  justify-content: ${props => props.resize && !props.resizeOpen ? 'center' : 'flex-start'};
  letter-spacing: 0.08em;
  font-size: 0.65rem;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.45);

  span {
    display: ${props => props.resize && !props.resizeOpen ? 'none' : 'block'};
    align-self: center;
  }
  i {
    display: ${props => props.resize && !props.resizeOpen ? 'block' : 'none'};
    align-self: center;
  }

  @media (max-width: 992px) {
    display: flex;
    justify-content: flex-start;

    span {
      display: block;
    }
    i {
      display: none;
    }
  }
`

Nav.Swipe = styled.div`
  display: none;
  position: fixed;
  width: 30px;
  height: 100%;
  z-index: 1;

  @media (max-width: 992px) {
    display: block;
  }
`

/* Start Brand */
Nav.Brand = styled.div`
  color: ${primary};
  position: fixed;
  width: ${props => props.resize && !props.resizeOpen ? widthResize : widthFull};
  height: ${props => props.resize && !props.resizeOpen ? heightHeader : '88px'};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${navy};
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding: 0 ${props => props.resize && !props.resizeOpen ? '8' : '16'}px;
  transition: width 0.28s ease, height 0.28s ease;
  z-index: 1;

  @media (max-width: 992px) {
    padding: 0 16px;
    justify-content: center;
    width: ${widthFull};
    height: 88px;
  }
`

Nav.Brand.Link = styled.a`
  align-self: center;
  display: flex;
  justify-content: center;
`

Nav.Brand.Logo = styled.img`
  width: ${props => props.resize && !props.resizeOpen ? '42px' : '168px'};
  max-height: ${props => props.resize && !props.resizeOpen ? '42px' : '56px'};
  object-fit: contain;
  align-self: center;
  transition: width 0.28s ease;

  @media (max-width: 992px) {
    width: 160px;
    max-height: 52px;
  }
`

Nav.Brand.IconSize = styled.div`
  align-self: center;
  padding: 8px;
  cursor: pointer;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'flex'};
  justify-content: center;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.85);
  border-radius: ${radiusMd};
  transition: background 0.18s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }

  @media (max-width: 992px) {
    display: none;
  }
`

Nav.Brand.IconMobile = styled.div`
  align-self: center;
  display: none;
  padding: 8px;
  font-size: 1.1rem;
  color: #fff;

  @media (max-width: 992px) {
    display: flex;
  }
`
/* End Brand */

/* Start One Level */
Nav.OneLevel = styled.ul`
  padding: 8px 12px 24px;
  list-style: none;
`

Nav.OneLevel.Item = styled.li`
  padding-bottom: 4px;
  width: ${props => props.resize && !props.resizeOpen ? widthResizeWithPadding : '100%'};

  @media (max-width: 992px) {
    width: 100%;
  }
`

Nav.OneLevel.TitleContent = styled.div`
  display: flex;
  justify-content: ${props => props.resize && !props.resizeOpen ? 'center' : 'space-between'};
  background: ${props => props.active ? 'rgba(255, 255, 255, 0.08)' : 'transparent'};
  border-radius: ${radiusMd};
  padding: 10px 12px;
  cursor: pointer;
  margin-bottom: 2px;
  min-height: 42px;
  color: #fff;
  transition: background 0.18s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  &:hover div {
    padding-left: ${props => props.resize && !props.resizeOpen ? '0' : '4px'};
  }

  @media (max-width: 992px) {
    justify-content: space-between;
  }
`

Nav.OneLevel.Title = styled.div`
  align-self: center;
  transition: padding 0.18s ease;
  display: flex;
`

Nav.OneLevel.IconArrow = styled.span`
  align-self: center;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  transform: ${props => props.active ? 'rotate(225deg)' : 'rotate(135deg)'};
  transition: transform 0.2s ease;
  content: '';
  width: 6px;
  height: 6px;
  border-width: 1.5px 0 0 1.5px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.55);
  opacity: 0.8;

  @media (max-width: 992px) {
    display: inline-block;
  }
`

Nav.OneLevel.Icon = styled.span`
  margin-right: ${props => props.resize && !props.resizeOpen ? '' : '0.85rem'};
  display: flex;
  width: 20px;
  align-self: center;
  justify-content: center;
  font-size: 0.95rem;
  opacity: 0.9;

  @media (max-width: 992px) {
    margin-right: 0.85rem;
  }
`

Nav.OneLevel.Description = styled.span`
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  align-self: center;
  font-size: 0.86rem;
  font-weight: 500;

  @media (max-width: 992px) {
    display: inline-block;
  }
`
/* End One Level */

/* Start Second Level */
Nav.SecondLevel = styled.ul`
  list-style: none;
  padding: 0 0 6px 0;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : (props.active ? 'block' : 'none')};

  @media (max-width: 992px) {
    display: ${props => props.active ? 'block' : 'none'};
  }
`

Nav.SecondLevel.Item = styled.li`
  display: flex;
  justify-content: space-between;
  background: ${props => props.active ? primary : 'transparent'};
  color: #fff;
  box-shadow: ${props => props.active ? `0 8px 20px rgba(255, 21, 42, 0.35)` : 'none'};
  border-radius: ${radiusPill};
  padding: 9px 14px;
  cursor: pointer;
  margin: 2px 0;
  transition: background 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;

  &:hover {
    background: ${props => props.active ? primary : 'rgba(255, 255, 255, 0.08)'};
  }

  &:hover div {
    padding-left: 4px;
  }
`

Nav.SecondLevel.Title = styled.div`
  align-self: center;
  transition: padding 0.18s ease;
  display: flex;
  height: auto;
  min-height: 20px;
`

Nav.SecondLevel.Icon = styled.span`
  margin-right: 0.75rem;
  align-self: center;
  display: flex;
  width: 6px;
  height: 6px;
  border-radius: 10px;
  border: 1.5px solid rgba(255, 255, 255, 0.7);
  flex-shrink: 0;
`

Nav.SecondLevel.Description = styled.span`
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  font-weight: 500;
  font-size: 0.82rem;
  width: auto;
  align-self: center;
  color: #fff;

  @media (max-width: 992px) {
    display: inline-block !important;
  }
`
/* End Second Level */

export default Nav
